export default "__VITE_ASSET__C_UMW5Vp__"